<ng-container *ngIf="myMenuItems$ | async as menuItems">
    <div
        *ngIf="this.isEnvironmentListOpen"
        class="environment-list-container">
        <div>
            <img
                [src]="defaultEnvironmentLogo.path"
                class="environment-list-logo" />
        </div>
        <div
            *ngFor="let environmentLogo of environmentLogos"
            (click)="setDefaultLogo(environmentLogo, defaultEnvironmentLogo, true)">
            <img
                [src]="environmentLogo.path"
                class="environment-list-logo" />
        </div>
    </div>
    <div class="menu-wrapper">
        <div
            [ngClass]="[
                (domain$ | async) === 'ys' ? 'logo-container' : 'logo-container-up',
                !isSidebarOpen ? 'sidebar-closed-logo-container' : ''
            ]"
            class="logo-container">
            <ng-container *ngIf="isSidebarOpen; else topSidebarMenu">
                <div class="btn-group d-flex align-items-center nested-logo-container">
                    <svg-icon
                        *ngIf="(domain$ | async) === 'ys'"
                        [svgStyle]="{ 'width.px': 150 }"
                        src="assets/images/ys-logo-text-reversed.svg"
                        type="button">
                    </svg-icon>
                    <svg-icon
                        *ngIf="(domain$ | async) === 'up'"
                        [svgStyle]="{ 'width.px': 135, 'height.px': 36 }"
                        src="assets/images/upero.svg"
                        type="button">
                    </svg-icon>
                    <mat-icon
                        *ngIf="(user$ | async)?.permissions?.devFeatures?.domainSwitch"
                        [ngClass]="(domain$ | async) === 'ys' ? '' : 'upero-environment-list-toggle-arrow'"
                        (click)="toggleEnvironmentList()"
                        class="environment-list-toggle-arrow">
                        {{ this.isEnvironmentListOpen ? 'keyboard_arrow_left' : 'keyboard_arrow_right' }}
                    </mat-icon>
                </div>
            </ng-container>
            <ng-template #topSidebarMenu>
                <svg-icon
                    (click)="toggleEnvironmentList()"
                    [src]="
                        (domain$ | async) === 'ys'
                            ? 'assets/images/menu-icons/yss-logo-small.svg'
                            : 'assets/images/menu-icons/upero-logo-small.svg'
                    "
                    [svgStyle]="{ 'width.px': 50 }"
                    type="button">
                </svg-icon>
            </ng-template>
        </div>
        <div
            [ngClass]="[(domain$ | async) === 'ys' ? '' : 'upero', !isSidebarOpen ? 'align-items-center' : '']"
            class="menu-items-container">
            <ng-container>
                <ng-container *ngFor="let menuItem of menuItems">
                    <ng-container *ngIf="isSidebarOpen; else middleSidebarMenu">
                        <div class="menu-item-group-container">
                            <div
                                [routerLink]="menuItem.route ? menuItem.route : undefined"
                                [ngClass]="[
                                    menuItem.subMenus.length ? 'submenu-items' : 'no-submenu-items',
                                    menuItem.active || parentCollapsedAndChildActive(menuItem) ? 'active' : '',
                                    (domain$ | async) === 'ys' ? '' : 'upero-active'
                                ]"
                                (click)="toggleMenuItems(menuItem)"
                                class="menu-item-row">
                                <div style="display: flex; align-items: center; gap: 0.75em">
                                    <svg-icon
                                        *ngIf="menuItem.icon"
                                        [ngClass]="(domain$ | async) === 'ys' ? '' : 'upero-menu-item-icon'"
                                        [src]="menuItem.icon"
                                        class="menu-item-icon"
                                        type="button">
                                    </svg-icon>
                                    <span
                                        [ngClass]="(domain$ | async) === 'ys' ? '' : 'upero-menu-item-title'"
                                        class="menu-item-title">
                                        {{ menuItem.title }}
                                    </span>
                                </div>
                                <mat-icon
                                    *ngIf="menuItem.subMenus.length"
                                    [ngClass]="[
                                        menuItem.active ? 'active' : '',
                                        (domain$ | async) === 'ys' ? '' : 'upero-menu-item-icon'
                                    ]"
                                    class="menu-item-icon menu-arrow">
                                    {{ menuItem.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                                </mat-icon>
                            </div>
                            <ng-container *ngIf="menuItem.subMenus.length && !menuItem.collapsed">
                                <ng-container *ngFor="let subMenuitem of menuItem.subMenus">
                                    <div
                                        [ngClass]="[
                                            subMenuitem.active ? 'active-text' : '',
                                            subMenuitem.active && (domain$ | async) === 'ys' ? '' : 'upero-active-text',
                                            (domain$ | async) === 'ys' ? '' : 'upero-sub-menu-item-row'
                                        ]"
                                        [routerLink]="subMenuitem.route"
                                        [queryParams]="subMenuitem.queryParams"
                                        class="sub-menu-item-row">
                                        <div
                                            [ngClass]="[
                                                subMenuitem.active ? 'show-dot' : 'hide-dot',
                                                (domain$ | async) === 'ys' ? '' : 'upero-dot'
                                            ]"
                                            class="dot"></div>
                                        <span
                                            [ngClass]="(domain$ | async) === 'ys' ? '' : 'upero-sub-menu-title'"
                                            class="sub-menu-title">
                                            {{ subMenuitem.title }}
                                        </span>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-template #middleSidebarMenu>
                        <div
                            [ngClass]="[
                                parentCollapsedAndChildActive(menuItem) ? 'active' : '',
                                (domain$ | async) === 'ys' ? '' : 'upero-active',
                                (domain$ | async) === 'ys' ? '' : 'upero-middle-sidebar-container'
                            ]"
                            class="middle-sidebar-menu-icon-container">
                            <svg-icon
                                [ngClass]="[(domain$ | async) === 'ys' ? '' : 'upero-middle-sidebar-menu-icon']"
                                [src]="menuItem.icon"
                                [routerLink]="menuItem.route ? menuItem.route : undefined"
                                (mouseenter)="toggleCollapsedChildMenu(menuItem)"
                                class="middle-sidebar-menu-icon">
                            </svg-icon>
                            <div
                                *ngIf="hoveredMenuItem"
                                [ngClass]="getHoveredMenuPosition(hoveredMenuItem.menuGroup)"
                                class="hover-menu-container">
                                <div class="hover-menu-container_inner">
                                    <div
                                        [ngClass]="[
                                            parentCollapsedAndChildActive(hoveredMenuItem) ? 'active-text' : '',
                                            (domain$ | async) === 'ys' ? '' : 'upero-title',
                                            (domain$ | async) === 'ys' ? '' : 'upero-hovered-menu-item-title'
                                        ]"
                                        class="hovered-menu-item-container title">
                                        <span
                                            [ngClass]="
                                                (domain$ | async) === 'ys' ? '' : 'upero-hovered-menu-item-title'
                                            "
                                            class="menu-item-title">
                                            {{ hoveredMenuItem.title }}
                                        </span>
                                    </div>
                                    <div
                                        *ngFor="let hoverSubMenuItem of hoveredMenuItem.subMenus"
                                        [ngClass]="[
                                            hoverSubMenuItem.active ? 'active-text' : '',
                                            (domain$ | async) === 'ys' ? '' : 'upero-active-text',
                                            (domain$ | async) === 'ys' ? '' : 'upero-hovered-menu-item-container'
                                        ]"
                                        [routerLink]="hoverSubMenuItem.route"
                                        [queryParams]="hoverSubMenuItem.queryParams"
                                        class="hovered-menu-item-container">
                                        <div
                                            [ngClass]="[
                                                hoverSubMenuItem.active ? 'show-dot' : 'hide-dot',
                                                (domain$ | async) === 'ys' ? '' : 'upero-hovered-menu-dot'
                                            ]"
                                            class="dot"></div>
                                        <span
                                            [ngClass]="(domain$ | async) === 'ys' ? '' : 'upero-menu-item-title'"
                                            class="menu-item-title">
                                            {{ hoverSubMenuItem.title }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </ng-container>
            <div
                *ngIf="isSidebarOpen"
                (click)="toggleSidebar()"
                class="collapse-sidebar-row">
                <svg-icon
                    [ngClass]="(domain$ | async) === 'ys' ? '' : 'upero-menu-item-icon'"
                    class="menu-item-icon"
                    src="assets/images/menu-icons/collapse-menu.svg"
                    type="button">
                </svg-icon>
                <span
                    [ngClass]="(domain$ | async) === 'ys' ? '' : 'upero-collapse-sidebar-title'"
                    class="collapse-sidebar-title">
                    Collapse Sidebar
                </span>
            </div>
            <div
                [ngClass]="[
                    !isSidebarOpen ? 'collapsed-bottom-container' : '',
                    (domain$ | async) === 'ys' ? '' : 'upero-bottom-menu-container'
                ]"
                class="bottom-menu-container">
                <div
                    *ngIf="!isSidebarOpen"
                    style="display: flex; flex-direction: column; align-items: center; gap: 1.5em; cursor: pointer">
                    <svg-icon
                        [ngClass]="(domain$ | async) === 'ys' ? '' : 'upero-menu-item-icon'"
                        (click)="toggleSidebar()"
                        class="menu-item-icon"
                        src="assets/images/menu-icons/open-menu.svg"
                        type="button"></svg-icon>
                    <div class="line"></div>
                </div>
                <div
                    class="bottom-menu-icon-container"
                    *ngFor="let bottomMenuItem of bottomMenuItems$ | async; let i = index"
                    [ngClass]="[
                        bottomMenuItem.active ? 'active' : '',
                        (domain$ | async) === 'ys' ? '' : 'upero-active',
                        (domain$ | async) === 'ys' ? '' : 'upero-bottom-menu-icon-container'
                    ]"
                    [routerLink]="bottomMenuItem.defaultRoute">
                    <svg-icon
                        [ngClass]="(domain$ | async) === 'ys' ? '' : 'upero-menu-item-icon'"
                        [src]="bottomMenuItem.icon"
                        class="menu-item-icon"
                        type="button">
                    </svg-icon>
                </div>
            </div>
        </div>
    </div>
</ng-container>
